export default __webpack_public_path__ + "static/media/Pro-2b.4fe43f13.png";